module.exports = __webpack_public_path__ + "img/prize.21a226dc.svg";